import { supabase } from './supabase';
import { retry } from '../utils/async';
import type { TravelPlan } from '../types/travel';

export async function addTravelPlan(plan: Omit<TravelPlan, 'id' | 'created_at' | 'updated_at'>) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await retry(
      () => supabase
        .from('travel_plans')
        .insert([{
          user_id: user.id,
          title: plan.title,
          description: plan.description,
          start_date: plan.startDate.toISOString(),
          end_date: plan.endDate.toISOString(),
          location: plan.location,
          purpose: plan.purpose,
          budget: plan.budget,
          notes: plan.notes,
          status: 'planning'
        }])
        .select()
        .single(),
      3,
      1000
    );

    if (error) throw error;
    return data;
  } catch (err) {
    console.error('Error adding travel plan:', err);
    throw err;
  }
}